module.exports = __webpack_public_path__ + "img/2.ed0e8c5e.png";